import offers from '../../offers';
import { OfferWithLink } from '../../types';
import { InsurancesCoverage, InsurancesOffer } from './types';

export const splitOffers = (coverage: InsurancesCoverage) => {
  const activeOffers: OfferWithLink[] = [];
  const inactiveOffers: OfferWithLink[] = [];

  Object.entries(coverage).forEach((insurance) => {
    const [name, isCovered] = insurance as [InsurancesOffer, boolean];
    const offer = offers[name];

    if (isCovered) {
      activeOffers.push(offer);
    } else {
      inactiveOffers.push(offer);
    }
  });

  return { activeOffers, inactiveOffers };
};
